export type FeeType =
  | "IMBALANCE_TARIFF"
  | "PRODUCTION_TARIFF"
  | "CONSUMPTION_TARIFF";

export const feeTypeLabels: Record<FeeType, string> = {
  IMBALANCE_TARIFF: "Imbalance volume charge in the balancing area",
  PRODUCTION_TARIFF: "Balancing capacity fee for generation",
  CONSUMPTION_TARIFF: "Balancing capacity charge for consumption",
};

export type FeeCountry = "ESTONIA" | "LATVIA" | "LITHUANIA";

export const feeCountryLabels: Record<FeeCountry, string> = {
  ESTONIA: "EE",
  LATVIA: "LV",
  LITHUANIA: "LT",
};

export interface Fee {
  id: number;
  effectiveFrom: string;
  effectiveTo: string;
  costType: FeeType;
  country: FeeCountry;
  price: number;
  measurementUnit: string;
}

export interface FeeRequest {
  effectiveFrom: string;
  effectiveTo: string;
  costType: FeeType;
  country: FeeCountry;
  price: string;
}
